import { useReveal } from "@/hooks/useReveal";

const STEPS = [
  {
    title: "Territory check",
    text: "You tell us the territory and the channels you cover. We confirm whether it is open.",
  },
  {
    title: "Trial period",
    text: "An initial period on a non-exclusive basis while both sides find out whether this works.",
  },
  {
    title: "Exclusivity agreement",
    text: "Written exclusivity for an agreed territory and channel, for 3 years, against an agreed annual volume.",
  },
  {
    title: "Renewal",
    text: "Renewed on volume performance, not automatically and not on promises.",
  },
];

export default function Exclusivity() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section id="exclusivity" className="bg-white py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal max-w-[800px]">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            How exclusivity works
          </h2>
          <p className="mt-5 text-ink/70 text-[17px] md:text-lg leading-relaxed">
            Exclusivity is the reason a distributor invests in building a brand
            rather than just clearing stock, so we take it seriously. It is
            also earned rather than granted on day one.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-4 gap-6">
          {STEPS.map((step, i) => (
            <div
              key={step.title}
              className="relative bg-cream rounded-lg p-7 border border-cream-dark/60"
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-brand text-white font-serif font-semibold text-base">
                {i + 1}
              </div>
              <h3 className="mt-4 text-ink font-serif text-lg font-semibold">
                {step.title}
              </h3>
              <p className="mt-2 text-ink/70 text-[17px] leading-relaxed">
                {step.text}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-8 space-y-3 text-ink/70 text-[17px] leading-relaxed max-w-[800px]">
          <p>
            Channels can be split. A specialist health-food distributor and a
            foodservice distributor can hold different channels in the same
            territory without competing.
          </p>
          <p>
            We will tell you plainly if your territory is already committed. We
            do not sell the same territory twice.
          </p>
        </div>
      </div>
    </section>
  );
}